import Button from 'preact-material-components/Button';
import { tracker, UserActionType } from '../../../../tracking';
import { buyWithInstacredLandingRoute } from '../../../../alias/homeRoutes';
import style from './style.css';

const StartShoppingBtn = ({ startShopingUrl, pageKey, isUserStatus }) => {
  return (
    <Button
      className={
        isUserStatus ? style.startShoppingUserStatusBtn : style.startShoppingBtn
      }
      onClick={() => {
        tracker.trackUserInteraction(
          UserActionType.CLICK,
          !startShopingUrl ? 'start_shopping' : 'start_shoping_merchant',
          pageKey,
          '',
        );

        if (startShopingUrl) {
          window.parent.location.href = startShopingUrl;
        } else {
          window.location.href =
            window.location.origin +
            buyWithInstacredLandingRoute.path +
            window.location.search;
        }
      }}>
      Start Shopping
    </Button>
  );
};

export default StartShoppingBtn;



// WEBPACK FOOTER //
// ./routes/program-landing-page/components/startShoppingBtn/index.js